import Fab from '@material-ui/core/Fab';
import RemoveIcon from '@material-ui/icons/Remove';
import AddIcon from '@material-ui/icons/Add';
import React from 'react';

const styles = {
  icon: {},
  count: {
    fontSize: 18,
    verticalAlign: 'center',
    marginLeft: 10,
    marginRight: 10,
  },
};

const Quantity = ({ value, onChange, minimum = 0, maximum = 100 }) => <div>
  <Fab
    size="small"
    style={styles.icon}
    onClick={() => onChange(Math.max(minimum, value - 1))}
    color="secondary">
    <RemoveIcon/>
  </Fab>
  <span style={styles.count}>{value}</span>
  <Fab
    size="small"
    style={styles.icon}
    onClick={() => onChange(Math.min(value + 1, maximum))}
    color="secondary">
    <AddIcon/>
  </Fab>
</div>;

export default Quantity;



// WEBPACK FOOTER //
// ./src/components/Admin/TaskProfiles/TaskProfileDialog/ItemTypesGrid/Quantity.js